import React from 'react';
import take from 'lodash/take';
import css from './index.css';
import cs from 'classnames';

const Tags = ({tags, wrapperClassName, hugeTag, ...props}) => (
  <div className={wrapperClassName || ''} data-qa={props['data-qa'] || ''}>
    {(tags.length > 5 ? [...take(tags, 4), '...'] : tags)
      .map(i => (<span className={cs(
        css.tag,
        'qa-tag',
        `qa-tag-${i}`,
        hugeTag && css.hugeTag
      )} key={i}
      >{i}</span>))
    }
  </div>
);

export default Tags;



// WEBPACK FOOTER //
// ./src/components/common/LabeledInput/Tags/index.js